﻿export enum RoleEnum {    
    Admin = 'Admin',
    Anonymous = 'Anonymous',
    Registered = 'Registered',
    Service = 'Service',
    Public = 'Public',
    Office = 'Office',
    Manager = 'Manager',
    OrgUnit = 'OrgUnit',
    Institution = 'Institution',
    Company = 'Company',
    Community = 'Community',
    OfficeModerator = 'OfficeModerator',
    Anketar = 'Anketar'
}